import { Form, FormElement } from '@uplift/types';
import { restClient } from '../../client';

export type PreviewFormInput = {
  form_id: string;
};

export type PreviewFormOutput = {
  form: Form;
  elements: FormElement[];
};

export const previewForm = (data: PreviewFormInput) =>
  restClient.request<PreviewFormOutput>('/api/v1/form/preview', {
    method: 'POST',
    data
  });
